/**
 * Created by linjianxi on 2016/10/29.
 */
export const initHqpordIndex = (state) => {
  return state
}



// WEBPACK FOOTER //
// ./src/vuex/modules/hqpord_index/getter.js